import React, { Component } from "react";
import Select from "react-select";
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";
import { fetchZones, fetchBins, fetchLevels } from './api';

import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../../../actions/root_url';

const modalStyle = {
  width: '700px',
  height: '600px',
  marginLeft: '-10%',
  marginTop: '-20%',
}

const propTypes = {
  selectedRows: PropTypes.array,
  onSuccess: PropTypes.func,
}

const defaultProps = {
  onSuccess: () => { },
  selectedRows: [],
}

const prcessZoneData = (zones) => {
  return zones.map(zone => ({
    label: zone.Name,
    value: zone.id,
  }))
}

const prcessBinData = (bins) => {
  return bins.map(bin => ({
    label: bin.section_num,
    value: bin.id,
  }))
}

const processLevelData = (levels) => {
  return levels.map(level => ({
    label: level.bin_num,
    value: level.id,
    color: level.color,
  }));
}

const initialTableData = {
  rows: [],
  selectedRow: {
    label: '',
    value: '',
  }
}

class RowRenderer extends Component {
  PropTypes: {
      onDoubleClick: React.PropTypes.func
  };
  render() {
    return (<div onDoubleClick={() => { this.props.onDoubleClick(this.props.row); }}><ReactDataGrid.Row ref="row" {...this.props} /></div>);
  }
}

class LocationSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // location: props.selectedRows.length ? props.selectedRows[0].Location : '',
      zoneTable: {
        ...initialTableData,
      },
      binTable: {
        ...initialTableData,
      },
      levelTable: {
        ...initialTableData,
      },

    };
  }

  componentDidMount() {
    this.fetchZones();
  }

  handleConfirmClick = () => {
    const payload = {
      location: this.generateSelectedLocation(),
      color: this.state.levelTable.selectedRow.color,
    };
    this.props.onConfirm(payload);
  }

  fetchZones = () => {
    const success = (zones) => {
      this.setState({
        zoneTable: {
          ...this.state.zoneTable,
          rows: prcessZoneData(zones),
        }
      });
    }
    fetchZones(1, success);
  }

  handleZoneSelect = (row) => {
    this.setState({
      zoneTable: {
        ...this.state.zoneTable,
        selectedRow: row,
      },
      binTable: {
        ...initialTableData,
      },
      levelTable: {
        ...initialTableData,
      },
    });

    const success = (bins) => {
      this.setState({
        binTable: {
          ...this.state.binTable,
          rows: prcessBinData(bins),
        },
      })
    }
    fetchBins(row.value, success)
  }

  handleBinSelect = (bin) => {
    const {
      zoneTable,
      binTable,
    } = this.state;

    this.setState({
      binTable: {
        ...this.state.binTable,
        selectedRow: bin,
      },
      levelTable: {
        ...initialTableData,
      }
    });
    const success = (levels) => {
      this.setState({
        levelTable: {
          ...this.state.levelTable,
          rows: processLevelData(levels),
        }
      })
    }

    fetchLevels(bin.value, success);
  }

  handleLevelSelect = (level) => {
    this.setState({
      levelTable: {
        ...this.state.levelTable,
        selectedRow: level,
      },
    })
  }

  renderZoneTable = () => {
    const getRows = () => Data.Selectors.getRows(this.state.zoneTable);
    const getSize = () => getRows().length;
    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return Object.assign({}, rows[rowIdx]);
    };

    const columns = [{
      key: 'label',
      name: <Translate value="zone" />,
      resizable: true,
      sortable: true,
      // width: 200,
      filterable: true,
    }];

    return (
      <ReactDataGrid
        rowRenderer={<RowRenderer onDoubleClick={this.handleZoneSelect} />}
        columns={columns}
        rowGetter={rowGetter}
        rowsCount={getSize()}
      />
    )
  }

  renderBinTable = () => {
    const getRows = () => Data.Selectors.getRows(this.state.binTable);
    const getSize = () => getRows().length;
    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return Object.assign({}, rows[rowIdx]);
    };

    const columns = [{
      key: 'label',
      name: <Translate value="bin" />,
      resizable: true,
      sortable: true,
      // width: 200,
      filterable: true,
    }];

    return (
      <ReactDataGrid
        rowRenderer={<RowRenderer onDoubleClick={this.handleBinSelect} />}
        columns={columns}
        rowGetter={rowGetter}
        rowsCount={getSize()}
      />
    )
  }

  renderLevelTable = () => {
    const getRows = () => Data.Selectors.getRows(this.state.levelTable);
    const getSize = () => getRows().length;
    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return Object.assign({}, rows[rowIdx]);
    };

    const columns = [{
      key: 'label',
      name: <Translate value="level" />,
      resizable: true,
      sortable: true,
      // width: 200,
      filterable: true,
    }];

    return (
      <ReactDataGrid
        rowRenderer={<RowRenderer onDoubleClick={this.handleLevelSelect} />}
        columns={columns}
        rowGetter={rowGetter}
        rowsCount={getSize()}
      />
    )
  }

  generateSelectedLocation = () => {
    const {
      zoneTable,
      binTable,
      levelTable,
    } = this.state;
    
    let location = '';
    if (zoneTable.selectedRow.value) {
      location = zoneTable.selectedRow.label;
    }
    if (binTable.selectedRow.value) {
      location = `${location}-${binTable.selectedRow.label}`;
    }
    if (levelTable.selectedRow.value) {
      location = `${location}-${levelTable.selectedRow.label}`;
      
    }
    return location;
  }

  render() {
  
    return (
      <div style={{ width: '100%', height: '100%', padding: '10px' }}>
        <div style={{ display: 'flex', fontSize: '40px', flexDirection: 'row', textAlign: 'center', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{ paddingRight: '10px' }}>Selected Location:  </div>
          <div>{this.generateSelectedLocation()}</div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', heiight: '', border: '1px olid red' }}>
          <div style={{ width: '33.3%', border: '1px solid green' }}>
            {this.renderZoneTable()}
          </div>
          <div style={{ width: '33.3%', border: '1px solid green' }}>
            {this.renderBinTable()}
          </div>
          <div style={{ width: '33.3%', border: '1px solid green' }}>
            {this.renderLevelTable()}
          </div>
        </div>
        <div style={{ width: '100%', justifyContent: 'end', alignContent: 'end', textAlign: 'end', alignItems: 'end', paddingTop: '40px' }}>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            // disabled={selectedRows.length !== 1}
            onClick={this.handleConfirmClick}
          >
            {/* <em className="fa fa-pencil" /> */}
            <Translate value="confirm" />
          </Button>
        </div>
      </div>
    )
  }
}

const LocationSelectModal = ({ setModalVisibility, isVisible, onConfirm, editingLine }) => (
  <SkyLightStateless
    title={'Location Select'}
    onCloseClicked={setModalVisibility}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <LocationSelect onConfirm={onConfirm} selectedWarehouse={1} editingLine={editingLine} />
  </SkyLightStateless>
)

LocationSelectModal.propTypes = propTypes
LocationSelectModal.defaultProps = defaultProps

export default LocationSelectModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/warehouseManagement/LocationSelectModal.jsx